import React from "react";
import { ChevronRight } from "../icons";
import iconStyles from "../icons/index.module.scss";
import styles from "./index.module.scss";
export default ({ segments, mobileOnly, embedded, }) => {
    const parents = segments.slice(0, -1);
    const current = segments.at(-1) ?? "";
    return (React.createElement("div", { className: `${styles.breadcrumb} ${mobileOnly ? styles.mobileOnly : ""} ${embedded ? styles.embedded : ""}` },
        React.createElement("div", { className: styles.trail },
            React.createElement("span", { className: styles.parent }, "Predict Instant"),
            parents.map((segment) => (React.createElement(React.Fragment, { key: segment },
                React.createElement("span", { className: styles.chevronWrap },
                    React.createElement(ChevronRight, { className: `${iconStyles.icon} ${iconStyles.chevron}` })),
                React.createElement("span", { className: styles.segment }, segment)))),
            React.createElement("span", { className: styles.chevronWrap },
                React.createElement(ChevronRight, { className: `${iconStyles.icon} ${iconStyles.chevron}` })),
            React.createElement("span", { className: styles.current }, current))));
};
